/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Przeciągnij, aby zmienić rozmiar panelu',
  command_intelligence_close_aria: 'Zamknij asystenta',
  command_intelligence_send_aria: 'Wyślij wiadomość',
  command_intelligence_stop_aria: 'Zatrzymaj odpowiedź',
  command_intelligence_composer_input_aria: 'Wiadomość do Command Intelligence',
  command_intelligence_drawer_more_options: 'Więcej opcji',
  command_intelligence_dock_position: 'Pozycja dokowania',
  command_intelligence_dock_left: 'Lewo',
  command_intelligence_dock_right: 'Prawo',
  command_intelligence_dock_top: 'Góra',
  command_intelligence_dock_bottom: 'Dół',
  command_intelligence_panel_layout: 'Układ panelu',
  command_intelligence_panel_layout_overlap: 'Nakładaj na treść',
  command_intelligence_panel_layout_push: 'Przesuwaj treść',
  command_intelligence_panel_auto_hide_overlap: 'Ukrywaj automatycznie po kliknięciu na zewnątrz',
  command_intelligence_session_reset: 'Resetuj rozmowę',
  command_intelligence_try_one_of_these: 'Wypróbuj jedną z tych opcji',
  command_intelligence_attach_hint: 'Dołącz elementy kontekstu, aby zacząć zadawać pytania.',
  command_intelligence_attach_modal_title: 'Dołącz kontekst',
  command_intelligence_attach_modal_subtitle: 'Wybierz z elementów w tym widoku. Już dołączone elementy są wyszarzone.',
  command_intelligence_attach_modal_search_placeholder: 'Szukaj…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# element dostępny} few {# elementy dostępne} many {# elementów dostępnych} other {# elementu dostępnego}} · {selected} wybrano',
  command_intelligence_attach_modal_empty: 'Brak elementów do dołączenia',
  command_intelligence_attach_modal_no_results: 'Żaden element nie pasuje do wyszukiwania',
  command_intelligence_context_bar_attached_section: 'Dołączone ({count})',
  command_intelligence_context_bar_clear_attached: 'Wyczyść',
  command_intelligence_context_bar_add: 'Dołącz kontekst',
  command_intelligence_placeholder_ready: 'Zadaj pytanie…',
  command_intelligence_placeholder_attach: 'Dołącz kontekst, aby zadać pytanie…',
  command_intelligence_composer_submit_hint: 'Enter, aby wysłać · Shift+Enter dla nowej linii',
  command_intelligence_composer_stop_hint: 'Zatrzymaj · szkic następnej wiadomości podczas oczekiwania',
  command_intelligence_response_stopped: 'Odpowiedź zatrzymana',
  command_intelligence_generation_in_progress: 'Przetwarzanie pytania',
  command_intelligence_generation_trace_title: 'Wykonane kroki',
  command_intelligence_generation_trace_toggle: 'Pokaż kroki',
  command_intelligence_generation_trace_summary: '{completed} z {total} kroków ukończono',
  command_intelligence_generation_trace_summary_generic: 'Kroki generowania',
  command_intelligence_generation_tool_count:
    '{count, plural, one {# narzędzie} few {# narzędzia} many {# narzędzi} other {# narzędzia}}',
  command_intelligence_generation_turn_label: 'Tura {turn} z {total}',
  command_intelligence_generation_turn_completed: 'Ukończono turę {turn} z {total}',
  command_intelligence_generation_turn_completed_elapsed: 'Ukończono turę {turn} z {total} ({seconds}s upłynęło)',
  command_intelligence_generation_turn_completed_with_tools: 'Ukończono turę {turn} z {total} – użyto {tools}',
  command_intelligence_generation_tools_used: 'Użyto {tools}',
  command_intelligence_reasoning_thinking: 'Myślę…',
  command_intelligence_reasoning_thought_for_seconds: 'Myślał przez {seconds} sekund',
  command_intelligence_reasoning_waiting: 'Przetwarzanie pytania…',
  command_intelligence_attach_modal_done: 'Gotowe',
  command_intelligence_attach_modal_attached_badge: 'dołączono',
  command_intelligence_attach_modal_attach: 'Dołącz',
  command_intelligence_attach_modal_attach_count: 'Dołącz ({count})',
  command_intelligence_attach_modal_close_aria: 'Zamknij selektor',
  command_intelligence_session_limit_context: 'Osiągnięto limit kontekstu. Zresetuj rozmowę, aby kontynuować.',
  command_intelligence_session_limit_prompt: 'Osiągnięto limit wiadomości. Zresetuj rozmowę, aby kontynuować.',
  command_intelligence_suggested_followups: 'Sugerowane dalsze pytania',
  command_intelligence_credit_warning_line: '{pct}% miesięcznych kredytów AI dla {scope} wykorzystano',
  command_intelligence_tooltip_prompts: '{count} z {max} wiadomości ({pct}%)',
  command_intelligence_tooltip_context: '{used} z {max} tokenów kontekstu ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Użycie kontekstu pojawia się po pierwszej odpowiedzi',
  command_intelligence_credits_loading: 'Ładowanie kredytów…',
  command_intelligence_credits_unavailable: 'Kredyty niedostępne',
  command_intelligence_credits_tooltip: 'Miesięczne kredyty AI za {monthKey}',
  command_intelligence_credits_tooltip_short: 'Miesięczne kredyty AI',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Jednostka',
  command_intelligence_credits_used_of_cap: '{used} z {cap} kredytów',
  command_intelligence_credits_used_no_cap: '{used} kredytów wykorzystano',
  command_intelligence_credits_monthly_title: 'Miesięczne kredyty AI',
  command_intelligence_compare_aria: 'Porównaj agentów',
  command_intelligence_compare_tooltip: 'Uruchom to samo pytanie na wielu profilach agentów',
  command_intelligence_compare_cancelled: 'Porównanie anulowane',
  command_intelligence_compare_branch_failed: 'Gałąź porównania nie powiodła się',
  command_intelligence_compare_title: 'Porównanie agentów',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} wej. / {outTok} wyj. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Dobra odpowiedź',
  command_intelligence_feedback_bad_response: 'Zła odpowiedź',
  command_intelligence_feedback_dialog_title: 'Prześlij opinię',
  command_intelligence_feedback_dialog_body:
    'Pomóż nam się poprawić, przesyłając opinię o tej odpowiedzi. Twoja opinia zostanie wysłana do naszego zespołu operacyjnego.',
  command_intelligence_feedback_response_label: 'Odpowiedź',
  command_intelligence_feedback_input_label: 'Twoja opinia (opcjonalnie)',
  command_intelligence_feedback_input_placeholder: 'Co było nie tak lub mało pomocne w tej odpowiedzi?',
  command_intelligence_feedback_submit: 'Wyślij opinię',
  command_intelligence_feedback_submit_error: 'Nie udało się wysłać opinii. Spróbuj ponownie.',
  command_intelligence_feedback_question_understanding: 'Czy agent zrozumiał, czego chciałeś?',
  command_intelligence_feedback_question_readability: 'Czy odpowiedź była łatwa do przeczytania i użycia?',
  command_intelligence_feedback_section_understanding: 'Zrozumienie',
  command_intelligence_feedback_section_readability: 'Czytelność',
  command_intelligence_feedback_choice_none: 'Brak',
  command_intelligence_feedback_choice_misunderstood_task: 'Niezrozumiane zadanie',
  command_intelligence_feedback_choice_ignored_constraint: 'Zignorowane ograniczenie',
  command_intelligence_feedback_choice_wrong_scope: 'Niewłaściwy zakres',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Trudne do odczytania wizualnie',
  command_intelligence_feedback_choice_wrote_too_much: 'Zbyt długa odpowiedź',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Wyjaśnienie niegodne zaufania',
  command_intelligence_copy_aria: 'Kopiuj do schowka',
  command_intelligence_error_missing_invoke_permission:
    'Nie masz uprawnień do używania Command Intelligence dla tego agenta. Poproś administratora o nadanie wymaganych uprawnień Intelligence (na przykład analyst).',
  command_intelligence_access_denied_title: 'Wymagany dostęp',
  command_intelligence_error_session_expired: 'Twoja sesja wygasła. Odśwież stronę i zaloguj się ponownie.',
};
